/*
    🔥 BARRAS DE HERRAMIENTAS DE QUILL

    Tres niveles, mismo motor. La diferencia es cuánto le ofrecés al
    usuario: un campo de comentarios no necesita tablas ni colores, y
    una nota de blog sí.

    ⚠️ Cada botón que agregás es una decisión que el usuario puede
       tomar mal. Más barra no es siempre mejor.
*/

export const QUILL_PRESETS = {

    // Para comentarios y notas cortas
    minimal: {
        toolbar: [
            ['bold', 'italic', 'underline'],
            ['link'],
            ['clean'],
        ],
    },

    // El equilibrio para la mayoría de los casos
    basic: {
        toolbar: [
            [{ header: [2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link', 'blockquote', 'code-block'],
            ['clean'],
        ],
    },

    // Para redacción larga: colores, alineación, medios
    full: {
        toolbar: [
            [{ font: [] }, { size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ color: [] }, { background: [] }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ align: [] }],
            ['blockquote', 'code-block'],
            ['link', 'image', 'video'],
            ['clean'],
        ],
    },
};

export const QUILL_FORMATS_FULL = [
    'font', 'size', 'header', 'bold', 'italic', 'underline', 'strike',
    'color', 'background', 'script', 'list', 'indent', 'align',
    'blockquote', 'code-block', 'link', 'image', 'video',
];
